(function(){
'use strict';
var mount=document.getElementById('ujdl-cv3');
if(!mount)return;
var root=mount.attachShadow({mode:'open'});
var NAVY='#1B3A6B',GOLD='#C9A84C';

/* ── CSS ── */
var css='@import url(\'https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Lato:ital,wght@0,300;0,400;0,700;1,300;1,400&display=swap\');'
  +':host{all:initial!important;display:block!important}'
  +'*{box-sizing:border-box}'
  +'.wrap{font-family:\'Lato\',system-ui,sans-serif;font-size:16px;line-height:1.6;color:#1e293b;max-width:720px;margin:0 auto 60px auto}'
  +'.panel{background:#fff;border:1px solid #e8e0d0;border-radius:20px;box-shadow:0 8px 40px rgba(27,58,107,.08);padding:50px 40px;position:relative;overflow:hidden}'
  +'.panel::before{content:\'\';position:absolute;top:0;left:0;right:0;height:4px;background:linear-gradient(90deg,#1B3A6B 0%,#C9A84C 50%,#1B3A6B 100%)}'
  +'@media(max-width:600px){.panel{padding:28px 16px;border-radius:14px}}'
  +'.gold-line{height:1px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);margin:22px 0;opacity:.6}'
  +'.form-header{text-align:center;margin-bottom:36px}'
  +'.emblem{width:68px;height:68px;background:linear-gradient(135deg,#1B3A6B,#2a5298);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 18px;font-size:28px;box-shadow:0 6px 20px rgba(27,58,107,.25)}'
  +'.form-title{font-family:\'Cinzel\',serif;font-size:27px;font-weight:700;color:#1B3A6B;margin:0 0 8px}'
  +'.form-subtitle{font-size:15px;color:#64748b;font-style:italic;margin:0}'
  +'.person-block{background:#fafaf8;border:1px solid #e8e0d0;border-radius:14px;padding:22px 20px;margin-bottom:16px}'
  +'.person-label{font-family:\'Cinzel\',serif;font-size:12px;font-weight:600;color:#C9A84C;text-transform:uppercase;letter-spacing:1.5px;margin-bottom:14px;display:flex;align-items:center;gap:8px}'
  +'.person-dot{width:7px;height:7px;background:#C9A84C;border-radius:50%}'
  +'.fields-row{display:flex;gap:12px;margin-bottom:10px}'
  +'@media(max-width:500px){.fields-row{flex-direction:column;gap:8px}}'
  +'.field-wrap{flex:1}'
  +'.field-label{font-size:11px;font-weight:700;color:#94a3b8;text-transform:uppercase;letter-spacing:.8px;margin-bottom:4px;display:block}'
  +'.field-input{width:100%;padding:12px 13px;border:1.5px solid #ddd8cc;border-radius:9px;font-size:15px;font-family:\'Lato\',sans-serif;color:#1e293b;background:#fff;outline:none;transition:border-color .25s,box-shadow .25s;-webkit-appearance:none}'
  +'.field-input:focus{border-color:#1B3A6B;box-shadow:0 0 0 3px rgba(27,58,107,.1)}'
  +'.field-input::placeholder{color:#b0a898;font-style:italic}'
  +'.error-box{display:none;background:#fff5f5;color:#c0392b;border:1px solid #f9b9b7;border-radius:9px;padding:11px 14px;font-size:14px;text-align:center;margin-bottom:14px;font-weight:500}'
  +'.btn-reveal{display:block;width:100%;max-width:340px;margin:8px auto 0;padding:15px 30px;background:linear-gradient(135deg,#1B3A6B,#2a5298);color:#fff;font-family:\'Cinzel\',serif;font-size:17px;font-weight:600;border:none;border-radius:50px;cursor:pointer;box-shadow:0 6px 20px rgba(27,58,107,.28);transition:transform .25s,box-shadow .25s;letter-spacing:.4px}'
  +'.btn-reveal:hover{transform:translateY(-2px);box-shadow:0 10px 28px rgba(27,58,107,.35)}'
  +'.privacy-note{text-align:center;font-size:12px;color:#94a3b8;margin-top:14px}'
  +'.loading-wrap{text-align:center;padding:70px 20px}'
  +'.loading-ring{width:80px;height:80px;border:3px solid #e8e0d0;border-top:3px solid #1B3A6B;border-right:3px solid #C9A84C;border-radius:50%;margin:0 auto 28px;animation:spin 1.4s linear infinite}'
  +'@keyframes spin{to{transform:rotate(360deg)}}'
  +'.loading-title{font-family:\'Cinzel\',serif;font-size:20px;color:#1B3A6B;margin-bottom:8px}'
  +'.loading-steps{font-size:13px;color:#94a3b8;font-style:italic;min-height:20px}'
  +'.result-header{text-align:center;margin-bottom:30px}'
  +'.result-title{font-family:\'Cinzel\',serif;font-size:25px;color:#1B3A6B;font-weight:700;margin:0 0 6px}'
  +'.result-names{font-size:17px;color:#C9A84C;font-weight:700;font-style:italic}'
  +'.score-card{border:2px solid;border-radius:16px;padding:28px 22px;text-align:center;margin-bottom:26px}'
  +'.score-eyebrow{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:2px;margin-bottom:6px;opacity:.75}'
  +'.score-icon{font-size:34px;margin-bottom:10px}'
  +'.score-label{font-family:\'Cinzel\',serif;font-size:21px;font-weight:700;margin-bottom:4px}'
  +'.score-number{font-size:62px;font-weight:900;font-family:\'Cinzel\',serif;line-height:1;margin:8px 0}'
  +'.score-bar-track{height:10px;background:rgba(0,0,0,.08);border-radius:10px;margin:14px 0 8px;overflow:hidden}'
  +'.score-bar-fill{height:100%;border-radius:10px;transition:width 1.2s ease}'
  +'.gauges-section{margin-bottom:28px}'
  +'.gauges-title{font-family:\'Cinzel\',serif;font-size:13px;font-weight:700;color:#1B3A6B;text-transform:uppercase;letter-spacing:1px;margin-bottom:14px;text-align:center}'
  +'.gauge-row{display:flex;align-items:center;gap:10px;margin-bottom:16px}'
  +'.gauge-icon{font-size:17px;width:22px;text-align:center;flex-shrink:0}'
  +'.gauge-meta{width:140px;flex-shrink:0}'
  +'@media(max-width:480px){.gauge-meta{width:95px}}'
  +'.gauge-name{font-size:12px;font-weight:700;color:#1B3A6B}'
  +'.gauge-sub{font-size:11px;color:#94a3b8;line-height:1.3;margin-top:2px}'
  +'.gauge-track{flex:1;height:8px;background:#e8e0d0;border-radius:8px;overflow:hidden}'
  +'.gauge-fill{height:100%;border-radius:8px;background:linear-gradient(90deg,#1B3A6B,#C9A84C);transition:width 1.1s ease}'
  +'.gauge-pct{font-family:\'Cinzel\',serif;font-size:12px;font-weight:700;color:#C9A84C;width:34px;text-align:right;flex-shrink:0}'
  +'.ai-card{background:#fafaf8;border:1px solid #e8e0d0;border-radius:14px;padding:26px 22px;margin-bottom:26px}'
  +'.ai-header{display:flex;align-items:center;gap:10px;margin-bottom:16px}'
  +'.ai-badge{font-family:\'Cinzel\',serif;font-size:11px;font-weight:700;color:#C9A84C;text-transform:uppercase;letter-spacing:1.5px}'
  +'.ai-title{font-family:\'Cinzel\',serif;font-size:17px;color:#1B3A6B;font-weight:700;margin-bottom:14px}'
  +'.ai-block{margin-bottom:16px}'
  +'.ai-block-title{font-family:\'Cinzel\',serif;font-size:12px;font-weight:700;color:#C9A84C;text-transform:uppercase;letter-spacing:1px;margin-bottom:5px}'
  +'.ai-block-text{font-size:15px;color:#374151;line-height:1.7}'
  +'.ai-divider{height:1px;background:linear-gradient(90deg,transparent,#e8e0d0,transparent);margin:14px 0}'
  +'.signature-card{background:#1B3A6B;border-radius:14px;padding:28px 22px;text-align:center;margin-bottom:24px;color:#fff}'
  +'.sig-eyebrow{font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:2px;color:#C9A84C;margin-bottom:6px}'
  +'.sig-number{font-family:\'Cinzel\',serif;font-size:68px;font-weight:700;color:#C9A84C;line-height:1;display:block;margin-bottom:4px}'
  +'.sig-title{font-family:\'Cinzel\',serif;font-size:16px;color:#e2d5b0;margin-bottom:14px}'
  +'.sig-text{font-size:14px;color:#b8cce4;line-height:1.65;max-width:480px;margin:0 auto}'
  +'.duo-card{background:linear-gradient(135deg,#f8f6f0,#fdfbf7);border:2px solid #e8d8b0;border-radius:16px;padding:30px 22px;margin-bottom:22px;position:relative;overflow:hidden}'
  +'.duo-card::before{content:\'\';position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,#C9A84C,#1B3A6B,#C9A84C)}'
  +'.duo-icon{font-size:36px;text-align:center;display:block;margin-bottom:10px}'
  +'.duo-title-text{font-family:\'Cinzel\',serif;font-size:19px;font-weight:700;color:#1B3A6B;text-align:center;margin-bottom:20px}'
  +'.fd-grid{display:grid;grid-template-columns:1fr 1fr;gap:14px}'
  +'@media(max-width:500px){.fd-grid{grid-template-columns:1fr}}'
  +'.fd-block{border-radius:10px;padding:15px}'
  +'.forces{background:#f0fdf4;border:1px solid #86efac}'
  +'.defis{background:#fff7ed;border:1px solid #fdba74}'
  +'.fd-header{font-size:12px;font-weight:700;text-transform:uppercase;letter-spacing:1px;margin-bottom:7px}'
  +'.fd-forces{color:#166534}'
  +'.fd-defis{color:#c2410c}'
  +'.fd-text{font-size:14px;line-height:1.6;color:#374151}'
  +'.cta-card{background:linear-gradient(135deg,#fffbf0,#fff9e8);border:1px solid #e8d8b0;border-radius:14px;padding:24px 20px;text-align:center;margin-bottom:22px}'
  +'.cta-eyebrow{font-size:11px;color:#94a3b8;text-transform:uppercase;letter-spacing:1px;margin-bottom:7px}'
  +'.cta-title{font-family:\'Cinzel\',serif;font-size:16px;color:#1B3A6B;font-weight:700;margin-bottom:7px}'
  +'.cta-text{font-size:14px;color:#4a5568;margin-bottom:14px;line-height:1.6}'
  +'.cta-btn{display:inline-block;padding:11px 26px;background:linear-gradient(135deg,#C9A84C,#b8933d);color:#fff;font-family:\'Cinzel\',serif;font-size:14px;font-weight:700;border-radius:50px;text-decoration:none;box-shadow:0 4px 14px rgba(201,168,76,.3)}'
  +'.actions-bar{display:flex;gap:12px;flex-wrap:wrap;justify-content:center;margin-bottom:16px}'
  +'.btn-action{display:flex;align-items:center;gap:8px;padding:12px 22px;border-radius:50px;font-family:\'Cinzel\',serif;font-size:14px;font-weight:600;cursor:pointer;border:2px solid;transition:all .25s;text-decoration:none;background:none}'
  +'.btn-pdf{background:#1B3A6B!important;color:#fff!important;border-color:#1B3A6B!important}'
  +'.btn-share{color:#C9A84C!important;border-color:#C9A84C!important}'
  +'.btn-share:hover{background:#C9A84C!important;color:#fff!important}'
  +'.btn-reset{color:#64748b!important;border-color:#cbd5e1!important;font-size:13px!important;padding:10px 18px!important}'
  +'.share-toast{display:none;background:#1B3A6B;color:#fff;border-radius:8px;padding:9px 16px;font-size:13px;text-align:center;margin-top:8px}'
  +'@keyframes fadeUp{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}'
  +'.fade-in{animation:fadeUp .5s ease forwards}'
  +'.fade-in-2{animation:fadeUp .5s ease .1s forwards;opacity:0}'
  +'.fade-in-3{animation:fadeUp .5s ease .2s forwards;opacity:0}'
  +'.fade-in-4{animation:fadeUp .5s ease .3s forwards;opacity:0}'
  +'.fade-in-5{animation:fadeUp .5s ease .4s forwards;opacity:0}';

var styleEl=document.createElement('style');
styleEl.textContent=css;
root.appendChild(styleEl);

/* ── DOM FORMULAIRE ── */
function el(tag,attrs,children){
  var e=document.createElement(tag);
  if(attrs)Object.keys(attrs).forEach(function(k){
    if(k==='className')e.className=attrs[k];
    else if(k==='style')e.style.cssText=attrs[k];
    else e.setAttribute(k,attrs[k]);
  });
  if(children){
    if(typeof children==='string')e.innerHTML=children;
    else children.forEach(function(c){if(c)e.appendChild(c)});
  }
  return e;
}
function txt(s){return document.createTextNode(s)}
function div(cls,inner){var d=document.createElement('div');d.className=cls;if(inner!==undefined)d.innerHTML=inner;return d;}
function inp(id,type,placeholder,maxl){
  var i=document.createElement('input');
  i.className='field-input';i.id=id;i.type=type||'text';
  i.placeholder=placeholder||'';i.autocomplete='off';
  if(maxl)i.maxLength=maxl;
  return i;
}
function lbl(txt){var s=document.createElement('span');s.className='field-label';s.textContent=txt;return s;}
function fieldWrap(labelTxt,inputEl){var w=div('field-wrap');w.appendChild(lbl(labelTxt));w.appendChild(inputEl);return w;}

function buildForm(){
  var wrap=div('wrap');
  var panel=div('panel');panel.id='formPanel';

  var header=div('form-header');
  var emb=div('emblem');emb.textContent='🧲';
  var title=document.createElement('h2');title.className='form-title';title.textContent='Compatibilité Énergétique';
  var sub=document.createElement('p');sub.className='form-subtitle';sub.textContent='Analyse numérologique avancée · 4 dimensions vibratoires · Lecture IA unique';
  header.appendChild(emb);header.appendChild(title);header.appendChild(sub);
  panel.appendChild(header);
  panel.appendChild(div('gold-line'));

  function personBlock(num){
    var pb=div('person-block');
    var lbl2=div('person-label');
    var dot=div('person-dot');
    lbl2.appendChild(dot);lbl2.appendChild(txt('Personne '+num));
    pb.appendChild(lbl2);
    var row=div('fields-row');
    row.appendChild(fieldWrap('Prénom',inp('prenom'+num,'text',num===1?'Votre prénom':'Son prénom')));
    row.appendChild(fieldWrap('Nom de naissance',inp('nom'+num,'text','Nom de naissance')));
    pb.appendChild(row);
    pb.appendChild(fieldWrap('Date de naissance',inp('date'+num,'tel','JJ/MM/AAAA',10)));
    return pb;
  }
  panel.appendChild(personBlock(1));
  panel.appendChild(personBlock(2));

  var errBox=div('error-box');errBox.id='errorMsg';panel.appendChild(errBox);

  var btnWrap=div('');btnWrap.style.cssText='text-align:center;margin-top:26px';
  var btn=document.createElement('button');btn.className='btn-reveal';btn.id='calcBtn';btn.textContent='✦ Révéler notre lien vibratoire ✦';
  var priv=div('privacy-note');priv.textContent='🔒 Analyse confidentielle · Aucune donnée conservée';
  btnWrap.appendChild(btn);btnWrap.appendChild(priv);
  panel.appendChild(btnWrap);

  wrap.appendChild(panel);

  // Loading
  var loading=div('panel');loading.id='loadingPanel';loading.style.display='none';
  var lw=div('loading-wrap');
  var ring=div('loading-ring');
  var lt=div('loading-title');lt.textContent='Analyse vibratoire en cours…';
  var ls=div('loading-steps');ls.id='loadingStep';ls.textContent='Calcul des chemins de vie…';
  lw.appendChild(ring);lw.appendChild(lt);lw.appendChild(ls);
  loading.appendChild(lw);
  wrap.appendChild(loading);

  // Result
  var res=div('');res.id='resultPanel';res.style.display='none';
  wrap.appendChild(res);

  return wrap;
}

var wrapper=buildForm();
root.appendChild(wrapper);

/* ── NUMÉROLOGIE ── */
function reduire(n,km){
  if(km&&(n===11||n===22||n===33))return n;
  while(n>9){if(km&&(n===11||n===22||n===33))return n;
    n=String(n).split('').reduce(function(a,b){return a+parseInt(b,10);},0);}
  return n;
}
function cheminVie(s){
  var sum=s.replace(/\D/g,'').split('').reduce(function(a,b){return a+parseInt(b,10);},0);
  return reduire(sum,true);
}
function cleanName(s){return s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toUpperCase().replace(/[^A-Z]/g,'');}
var NUM={A:1,B:2,C:3,D:4,E:5,F:6,G:7,H:8,I:9,J:1,K:2,L:3,M:4,N:5,O:6,P:7,Q:8,R:9,S:1,T:2,U:3,V:4,W:5,X:6,Y:7,Z:8};
var VOY=/[AEIOU]/;
function expression(p,n){var s=cleanName(p+n);if(!s)return 1;var sum=s.split('').reduce(function(a,c){return a+(NUM[c]||0);},0);return reduire(sum||1,true);}
function ame(p,n){var s=cleanName(p+n);if(!s)return 1;var sum=s.split('').filter(function(c){return VOY.test(c);}).reduce(function(a,c){return a+(NUM[c]||0);},0);return reduire(sum||1,true);}
function personnalite(p,n){var s=cleanName(p+n);if(!s)return 1;var sum=s.split('').filter(function(c){return !VOY.test(c);}).reduce(function(a,c){return a+(NUM[c]||0);},0);return reduire(sum||1,true);}
function compatScore(a,b){var x=a>9?reduire(a,false):a,y=b>9?reduire(b,false):b;var d=Math.abs(x-y),c=Math.min(d,9-d);return Math.round(100-(c/4.5)*70);}
function duoNum(a,b){return reduire(a+b,true);}
function isValidDate(s){
  if(!/^\d{2}\/\d{2}\/\d{4}$/.test(s))return false;
  var p=s.split('/'),d=+p[0],m=+p[1],y=+p[2];
  if(y<1900||y>new Date().getFullYear()||m<1||m>12)return false;
  var dim=[31,(y%4===0&&(y%100!==0||y%400===0))?29:28,31,30,31,30,31,31,30,31,30,31];
  return d>=1&&d<=dim[m-1];
}
function formatDate(el2){
  var v=el2.value.replace(/\D/g,'');
  if(v.length>8)v=v.substring(0,8);
  if(v.length>4)el2.value=v.substring(0,2)+'/'+v.substring(2,4)+'/'+v.substring(4,8);
  else if(v.length>2)el2.value=v.substring(0,2)+'/'+v.substring(2,4);
  else el2.value=v;
}
function scoreLabel(p){
  if(p>=85)return{label:'Résonance Exceptionnelle',icon:'🌟',color:'#166534',bg:'#f0fdf4',border:'#86efac'};
  if(p>=70)return{label:'Harmonie Profonde',icon:'💙',color:'#1e40af',bg:'#eff6ff',border:'#93c5fd'};
  if(p>=55)return{label:'Lien Complémentaire',icon:'🌀',color:'#92400e',bg:'#fffbeb',border:'#fcd34d'};
  if(p>=40)return{label:'Duo en Apprentissage',icon:'🔮',color:'#7e22ce',bg:'#faf5ff',border:'#d8b4fe'};
  return{label:'Connexion Karmique',icon:'⚡',color:'#9f1239',bg:'#fff1f2',border:'#fda4af'};
}
var DIM=[
  {k:'Cv',icon:'🌟',name:'Chemin de Vie',sub:'Direction de vie profonde, leçons karmiques'},
  {k:'Am',icon:'💙',name:"Nombre d'Âme",sub:'Désirs profonds, motivations intérieures'},
  {k:'Ex',icon:'✨',name:'Expression',sub:'Comment vous vous manifestez au monde'},
  {k:'Pe',icon:'🎭',name:'Personnalité',sub:"Image projetée vers l'extérieur"}
];
var DUOS={
  1:{t:'Duo Étincelle : Le Nouveau Départ',ic:'🔥'},
  2:{t:'Duo Fusion : Les Âmes Miroirs',ic:'💞'},
  3:{t:"Duo Rayonnant : L'Expression Créative",ic:'🌟'},
  4:{t:'Duo Racine : La Construction Solide',ic:'🌳'},
  5:{t:'Duo Magnétique : Le Vent de Liberté',ic:'🌬️'},
  6:{t:"Duo Cocon : L'Amour Guérisseur",ic:'🕊️'},
  7:{t:"Duo Spirituel : L'Élévation de l'Âme",ic:'🔮'},
  8:{t:'Duo Alchimique : La Force de Transformation',ic:'⚙️'},
  9:{t:"Duo Universel : L'Achèvement Karmique",ic:'🌌'},
  11:{t:'Duo Éveillé : La Mission de Lumière',ic:'💫'},
  22:{t:'Duo Architecte : Le Grand Oeuvre Commun',ic:'🏛️'},
  33:{t:"Duo Christique : L'Amour Universel Incarné",ic:'🕊️'}
};
function getDuo(n){return DUOS[n]||DUOS[reduire(n,false)]||DUOS[9];}

/* ── API CLAUDE ── */
function callClaude(cd){
  var prompt='Tu es un expert en numérologie vibratoire pour Un Lieu de Lumière.\n'
    +'Rédige une lecture numérologique personnalisée et unique pour ce duo.\n\n'
    +'DONNÉES :\n'
    +'Personne 1 : '+cd.nom1+'\n'
    +'- Chemin de Vie : '+cd.cv1+(cd.cv1>9?' (Nombre Maître)':'')+'\n'
    +'- Âme : '+cd.am1+' | Expression : '+cd.ex1+' | Personnalité : '+cd.pe1+'\n\n'
    +'Personne 2 : '+cd.nom2+'\n'
    +'- Chemin de Vie : '+cd.cv2+(cd.cv2>9?' (Nombre Maître)':'')+'\n'
    +'- Âme : '+cd.am2+' | Expression : '+cd.ex2+' | Personnalité : '+cd.pe2+'\n\n'
    +'Signature du duo : '+cd.duoN+' — '+cd.duoTitle+'\n'
    +'Score global : '+cd.score+'%\n\n'
    +'RÈGLES : jamais de termes médicaux. Vocabulaire énergétique, transformationnel. Ton chaleureux et profond. Utilise les prénoms naturellement. S\'appuyer sur les NOMBRES RÉELS. Textes complets.\n\n'
    +'FORMAT : Réponds UNIQUEMENT en utilisant les balises ci-dessous. N\'écris rien d\'autre, pas de JSON, pas de code.\n'
    +'<p1_titre>Titre poétique court pour '+cd.prenom1+'</p1_titre>\n'
    +'<p1_cv>2-3 phrases sur le CV '+cd.cv1+'</p1_cv>\n'
    +'<p1_ame>2 phrases sur l\'âme '+cd.am1+'</p1_ame>\n'
    +'<p1_ex>2 phrases sur l\'expression '+cd.ex1+'</p1_ex>\n'
    +'<p1_pe>2 phrases sur la personnalité '+cd.pe1+'</p1_pe>\n'
    +'<p2_titre>Titre poétique court pour '+cd.prenom2+'</p2_titre>\n'
    +'<p2_cv>2-3 phrases sur le CV '+cd.cv2+'</p2_cv>\n'
    +'<p2_ame>2 phrases sur l\'âme '+cd.am2+'</p2_ame>\n'
    +'<p2_ex>2 phrases sur l\'expression '+cd.ex2+'</p2_ex>\n'
    +'<p2_pe>2 phrases sur la personnalité '+cd.pe2+'</p2_pe>\n'
    +'<duo_ouv>1 paragraphe intro sur l\'énergie du duo</duo_ouv>\n'
    +'<duo_dyn>1 paragraphe dynamique CV '+cd.cv1+' et '+cd.cv2+'</duo_dyn>\n'
    +'<duo_prof>1 paragraphe résonance âmes '+cd.am1+' et '+cd.am2+'</duo_prof>\n'
    +'<duo_com>1 paragraphe expressions '+cd.ex1+' et '+cd.ex2+'</duo_com>\n'
    +'<duo_for>3-4 phrases forces du duo</duo_for>\n'
    +'<duo_def>3-4 phrases défis énergétiques</duo_def>\n'
    +'<duo_msg>message de clôture inspirant personnalisé</duo_msg>';

  return fetch('https://proxy-anthropic.christophe-f2b.workers.dev',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({
      model:'claude-sonnet-4-6',
      max_tokens:4000,
      system:'Tu es expert en numérologie vibratoire. Remplis strictement les balises demandées.',
      messages:[{role:'user',content:prompt}]
    })

  }).then(async function(resp){
  const txt = await resp.text();

  if (!resp.ok) {
    throw new Error('HTTP ' + resp.status + ' : ' + txt);
  }

  try {
    return JSON.parse(txt);
  } catch(err) {
    console.error("Réponse reçue :", txt);
    throw new Error("Le serveur a renvoyé un JSON invalide");
  }
})

  .then(function(result){
    if (!result || !result.content || !result.content[0]) {
      console.error("Structure API invalide:", result);
      throw new Error("Format de réponse inattendu de l'API");
    }
    var text = result.content[0].text;
    
    // Fonction robuste pour extraire le texte entre deux balises
    function extract(tag) {
      var regex = new RegExp("<" + tag + ">([\\s\\S]*?)<\\/" + tag + ">", "i");
      var match = text.match(regex);
      return match ? match[1].trim() : "";
    }
    
    var aiResult = {
      portrait1: {
        titre: extract("p1_titre") || "Portrait de " + cd.prenom1,
        cheminVie: extract("p1_cv"),
        ame: extract("p1_ame"),
        expression: extract("p1_ex"),
        personnalite: extract("p1_pe")
      },
      portrait2: {
        titre: extract("p2_titre") || "Portrait de " + cd.prenom2,
        cheminVie: extract("p2_cv"),
        ame: extract("p2_ame"),
        expression: extract("p2_ex"),
        personnalite: extract("p2_pe")
      },
      lectureDuo: {
        ouverture: extract("duo_ouv"),
        dynamique: extract("duo_dyn"),
        profondeur: extract("duo_prof"),
        communication: extract("duo_com"),
        forces: extract("duo_for"),
        defis: extract("duo_def"),
        message: extract("duo_msg")
      }
    };
    
    if (!aiResult.lectureDuo.ouverture && !aiResult.portrait1.cheminVie) {
        console.error("Texte reçu mais vide ou mal formaté :", text);
        throw new Error("L'IA n'a pas renvoyé l'analyse correctement.");
    }
    
    return aiResult;
  });
}

/* ── PDF ── */
function makePDF(cd,ai,si,duo){
  var p1=ai.portrait1,p2=ai.portrait2,ld=ai.lectureDuo;
  var date=new Date().toLocaleDateString('fr-FR');
  var w=window.open('','_blank','width=800,height=900');
  var gRow=function(icon,name,sub,v1,v2,sc){
    return '<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px">'
      +'<div style="width:20px;font-size:13px">'+icon+'</div>'
      +'<div style="width:120px;flex-shrink:0"><div style="font-size:11px;font-weight:700;color:#1B3A6B">'+name+'</div>'
      +'<div style="font-size:10px;color:#94a3b8">'+sub+'</div>'
      +'<div style="font-size:10px;color:#94a3b8">'+v1+' · '+v2+'</div></div>'
      +'<div style="flex:1;height:7px;background:#e8e0d0;border-radius:7px;overflow:hidden">'
      +'<div style="height:100%;width:'+sc+'%;background:linear-gradient(90deg,#1B3A6B,#C9A84C);border-radius:7px"></div></div>'
      +'<div style="font-size:11px;font-weight:700;color:#C9A84C;width:30px;text-align:right">'+sc+'%</div></div>';
  };
  var pCard=function(nom,titre,cv,cvt,am,amt,ex,ext,pe,pet){
    return '<div style="border:1px solid #e8e0d0;border-left:3px solid #1B3A6B;border-radius:10px;padding:16px;margin-bottom:14px;page-break-inside:avoid">'
      +'<div style="font-family:Cinzel,serif;font-size:14px;color:#1B3A6B;font-weight:700;margin-bottom:3px">'+nom+'</div>'
      +'<div style="font-size:12px;color:#C9A84C;font-weight:700;font-style:italic;margin-bottom:10px">'+titre+'</div>'
      +'<div style="font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.7px;margin-bottom:2px">🌟 Chemin de Vie '+cv+'</div>'
      +'<div style="font-size:12px;color:#374151;line-height:1.55;margin-bottom:8px">'+cvt+'</div>'
      +'<div style="height:1px;background:#f1ebe0;margin:6px 0"></div>'
      +'<div style="font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.7px;margin-bottom:2px">💙 Âme '+am+'</div>'
      +'<div style="font-size:12px;color:#374151;line-height:1.55;margin-bottom:8px">'+amt+'</div>'
      +'<div style="height:1px;background:#f1ebe0;margin:6px 0"></div>'
      +'<div style="font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.7px;margin-bottom:2px">✨ Expression '+ex+'</div>'
      +'<div style="font-size:12px;color:#374151;line-height:1.55;margin-bottom:8px">'+ext+'</div>'
      +'<div style="height:1px;background:#f1ebe0;margin:6px 0"></div>'
      +'<div style="font-size:10px;font-weight:700;color:#64748b;text-transform:uppercase;letter-spacing:.7px;margin-bottom:2px">🎭 Personnalité '+pe+'</div>'
      +'<div style="font-size:12px;color:#374151;line-height:1.55">'+pet+'</div>'
      +'</div>';
  };
  var html='<!DOCTYPE html><html lang="fr"><head><meta charset="UTF-8">'
    +'<title>Compatibilite Energetique</title>'
    +'<link href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;600;700&family=Lato:wght@400;700&display=swap" rel="stylesheet">'
    +'<style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:Lato,sans-serif;font-size:13px;line-height:1.65;color:#1e293b;background:#fff;padding:0}'
    +'.page{max-width:700px;margin:0 auto;padding:35px}'
    +'@media print{body{-webkit-print-color-adjust:exact;print-color-adjust:exact}.page{padding:20px}}</style></head>'
    +'<body><div class="page">'
    +'<div style="text-align:center;padding-bottom:22px;border-bottom:2px solid #e8e0d0;margin-bottom:24px">'
    +'<div style="width:55px;height:3px;background:linear-gradient(90deg,#1B3A6B,#C9A84C);margin:0 auto 14px"></div>'
    +'<div style="font-family:Cinzel,serif;font-size:20px;color:#1B3A6B;font-weight:700;margin-bottom:4px">Compatibilité Énergétique</div>'
    +'<div style="font-size:12px;color:#94a3b8;font-style:italic">Analyse numérologique avancée · 4 dimensions vibratoires</div>'
    +'<div style="font-family:Cinzel,serif;font-size:15px;color:#C9A84C;font-weight:700;margin-top:10px">'+cd.nom1+' &amp; '+cd.nom2+'</div>'
    +'<div style="font-size:11px;color:#94a3b8;margin-top:4px">Analyse du '+date+'</div></div>'
    +'<div style="font-family:Cinzel,serif;font-size:12px;font-weight:700;color:#C9A84C;text-transform:uppercase;letter-spacing:1.5px;margin-bottom:10px">Résonance Globale</div>'
    +'<div style="background:#f8f6f0;border:2px solid #e8d8b0;border-radius:12px;padding:18px;text-align:center;margin-bottom:20px">'
    +'<div style="font-family:Cinzel,serif;font-size:48px;font-weight:700;color:#1B3A6B;line-height:1">'+cd.score+'%</div>'
    +'<div style="font-family:Cinzel,serif;font-size:14px;color:#C9A84C;margin-top:4px">'+si.icon+' '+si.label+'</div></div>'
    +'<div style="font-family:Cinzel,serif;font-size:12px;font-weight:700;color:#C9A84C;text-transform:uppercase;letter-spacing:1.5px;margin-bottom:10px">Compatibilité par Dimension</div>'
    +'<div style="margin-bottom:20px">'
    +gRow('🌟','Chemin de Vie','Direction de vie, karma',cd.cv1,cd.cv2,cd.sCv)
    +gRow('💙',"Âme",'Désirs profonds',cd.am1,cd.am2,cd.sAm)
    +gRow('✨','Expression','Manifestation',cd.ex1,cd.ex2,cd.sEx)
    +gRow('🎭','Personnalité','Image projetée',cd.pe1,cd.pe2,cd.sPe)
    +'</div>'
    +'<div style="height:1px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);margin:18px 0;opacity:.5"></div>'
    +'<div style="font-family:Cinzel,serif;font-size:12px;font-weight:700;color:#C9A84C;text-transform:uppercase;letter-spacing:1.5px;margin-bottom:12px">Portraits Vibratoires</div>'
    +pCard(cd.nom1,p1.titre,cd.cv1,p1.cheminVie,cd.am1,p1.ame,cd.ex1,p1.expression,cd.pe1,p1.personnalite)
    +pCard(cd.nom2,p2.titre,cd.cv2,p2.cheminVie,cd.am2,p2.ame,cd.ex2,p2.expression,cd.pe2,p2.personnalite)
    +'<div style="height:1px;background:linear-gradient(90deg,transparent,#C9A84C,transparent);margin:18px 0;opacity:.5"></div>'
    +'<div style="background:#1B3A6B;border-radius:12px;padding:20px;color:#fff;text-align:center;margin-bottom:20px;page-break-inside:avoid">'
    +'<div style="font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:2px;color:#C9A84C;margin-bottom:6px">Signature vibratoire du duo</div>'
    +'<div style="font-family:Cinzel,serif;font-size:54px;font-weight:700;color:#C9A84C;line-height:1">'+cd.duoN+'</div>'
    +'<div style="font-family:Cinzel,serif;font-size:14px;color:#e2d5b0;margin:6px 0">'+duo.t+'</div>'
    +'<div style="font-size:12px;color:#b8cce4;line-height:1.6;margin-top:8px">'+ld.ouverture+'</div></div>'
    +'<div style="font-family:Cinzel,serif;font-size:12px;font-weight:700;color:#C9A84C;text-transform:uppercase;letter-spacing:1.5px;margin-bottom:12px">Lecture du Lien</div>'
    +'<div style="margin-bottom:12px"><div style="font-family:Cinzel,serif;font-size:11px;color:#C9A84C;text-transform:uppercase;letter-spacing:1px;margin-bottom:4px">⚡ Dynamique des Chemins de Vie</div><div style="font-size:12px;color:#374151;line-height:1.65">'+ld.dynamique+'</div></div>'
    +'<div style="margin-bottom:12px"><div style="font-family:Cinzel,serif;font-size:11px;color:#C9A84C;text-transform:uppercase;letter-spacing:1px;margin-bottom:4px">💙 Résonance des Âmes</div><div style="font-size:12px;color:#374151;line-height:1.65">'+ld.profondeur+'</div></div>'
    +'<div style="margin-bottom:16px"><div style="font-family:Cinzel,serif;font-size:11px;color:#C9A84C;text-transform:uppercase;letter-spacing:1px;margin-bottom:4px">✨ Communication du Duo</div><div style="font-size:12px;color:#374151;line-height:1.65">'+ld.communication+'</div></div>'
    +'<div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:16px">'
    +'<div style="background:#f0fdf4;border:1px solid #86efac;border-radius:8px;padding:12px"><div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.8px;color:#166534;margin-bottom:5px">✦ Forces du Duo</div><div style="font-size:12px;line-height:1.6;color:#374151">'+ld.forces+'</div></div>'
    +'<div style="background:#fff7ed;border:1px solid #fdba74;border-radius:8px;padding:12px"><div style="font-size:10px;font-weight:700;text-transform:uppercase;letter-spacing:.8px;color:#c2410c;margin-bottom:5px">⚡ Défis Énergétiques</div><div style="font-size:12px;line-height:1.6;color:#374151">'+ld.defis+'</div></div>'
    +'</div>'
    +'<div style="background:linear-gradient(135deg,#f8f6f0,#fdfbf7);border:1px solid #e8d8b0;border-radius:10px;padding:16px;text-align:center;margin-bottom:20px">'
    +'<div style="font-size:13px;font-style:italic;color:#4a5568;line-height:1.7">"'+ld.message+'"</div></div>'
    +'<div style="text-align:center;padding-top:18px;border-top:1px solid #e8e0d0">'
    +'<div style="font-family:Cinzel,serif;font-size:13px;color:#1B3A6B;font-weight:700">Un Lieu de Lumière</div>'
    +'<div style="font-size:11px;color:#94a3b8">unlieudelumiere.com</div></div>'
    +'</div><script>window.onload=function(){window.print();}<\/script></body></html>';
  w.document.write(html);
  w.document.close();
}

/* ── RENDU RÉSULTATS ── */
function renderResults(cd,ai){
  var si=scoreLabel(cd.score);
  var duo=getDuo(cd.duoN);
  var p1=ai.portrait1,p2=ai.portrait2,ld=ai.lectureDuo;

  var resPanel=root.getElementById('resultPanel');
  resPanel.innerHTML='';

  var panel=div('panel fade-in');

  // Header
  var rh=div('result-header');
  rh.innerHTML='<div class="result-title">✦ Lecture Vibratoire ✦</div>'
    +'<div class="result-names">'+cd.nom1+' &amp; '+cd.nom2+'</div>';
  panel.appendChild(rh);
  panel.appendChild(div('gold-line'));

  // Score
  var sc=div('score-card fade-in-2');
  sc.style.cssText='color:'+si.color+';background:'+si.bg+';border-color:'+si.border;
  sc.innerHTML='<div class="score-eyebrow">Résonance globale</div>'
    +'<div class="score-icon">'+si.icon+'</div>'
    +'<div class="score-label">'+si.label+'</div>'
    +'<div class="score-number">'+cd.score+'<span style="font-size:26px">%</span></div>'
    +'<div class="score-bar-track"><div class="score-bar-fill" id="scoreFill" style="width:0%;background:linear-gradient(90deg,'+NAVY+','+GOLD+')"></div></div>';
  panel.appendChild(sc);

  // Jauges
  var gs=div('gauges-section fade-in-3');
  var gt=div('gauges-title');gt.textContent='Compatibilité par Dimension';
  gs.appendChild(gt);
  var vals=[[cd.cv1,cd.cv2,cd.sCv,'gCv'],[cd.am1,cd.am2,cd.sAm,'gAm'],[cd.ex1,cd.ex2,cd.sEx,'gEx'],[cd.pe1,cd.pe2,cd.sPe,'gPe']];
  DIM.forEach(function(d,i){
    var row=div('gauge-row');
    row.innerHTML='<div class="gauge-icon">'+d.icon+'</div>'
      +'<div class="gauge-meta"><div class="gauge-name">'+d.name+'</div>'
      +'<div class="gauge-sub">'+d.sub+'<br>'+vals[i][0]+' · '+vals[i][1]+'</div></div>'
      +'<div class="gauge-track"><div class="gauge-fill" id="'+vals[i][3]+'" style="width:0%"></div></div>'
      +'<div class="gauge-pct">'+vals[i][2]+'%</div>';
    gs.appendChild(row);
  });
  panel.appendChild(gs);
  panel.appendChild(div('gold-line'));

  // Portraits IA
  var aic=div('ai-card fade-in-4');
  var aih=div('ai-header');
  aih.innerHTML='<span style="font-size:20px">✨</span><span class="ai-badge">Portraits Vibratoires · Lecture IA</span>';
  aic.appendChild(aih);

  function addPortrait(nom,p,cv,am,ex,pe){
    var t=div('ai-title');t.textContent=p.titre+' — '+nom;aic.appendChild(t);
    [{label:'🌟 Chemin de Vie '+cv,text:p.cheminVie},{label:'💙 Nombre d\'Âme '+am,text:p.ame},{label:'✨ Expression '+ex,text:p.expression},{label:'🎭 Personnalité '+pe,text:p.personnalite}]
    .forEach(function(b,i){
      var bl=div('ai-block');
      var bt=div('ai-block-title');bt.textContent=b.label;
      var bx=div('ai-block-text');bx.textContent=b.text;
      bl.appendChild(bt);bl.appendChild(bx);aic.appendChild(bl);
      if(i<3)aic.appendChild(div('ai-divider'));
    });
  }
  addPortrait(cd.nom1,p1,cd.cv1,cd.am1,cd.ex1,cd.pe1);
  aic.appendChild(div('gold-line'));
  addPortrait(cd.nom2,p2,cd.cv2,cd.am2,cd.ex2,cd.pe2);
  panel.appendChild(aic);

  // Signature
  var sig=div('signature-card fade-in-5');
  var sn=document.createElement('span');sn.className='sig-number';sn.textContent=cd.duoN;
  sig.innerHTML='<div class="sig-eyebrow">Signature vibratoire du duo</div>';
  sig.appendChild(sn);
  var stt=div('sig-title');stt.textContent=duo.t;
  var stx=div('sig-text');stx.textContent=ld.ouverture;
  sig.appendChild(stt);sig.appendChild(stx);
  panel.appendChild(sig);

  // Duo card
  var dc=div('duo-card fade-in-5');
  var di=div('duo-icon');di.textContent=duo.ic;
  var dt=div('duo-title-text');dt.textContent=duo.t;
  dc.appendChild(di);dc.appendChild(dt);

  [{label:'⚡ Dynamique des Chemins de Vie',text:ld.dynamique},{label:'💙 Résonance des Âmes',text:ld.profondeur},{label:'✨ Communication du Duo',text:ld.communication}]
  .forEach(function(b){
    var bl=div('ai-block');bl.style.marginBottom='14px';
    var bt=div('ai-block-title');bt.textContent=b.label;
    var bx=div('ai-block-text');bx.textContent=b.text;
    bl.appendChild(bt);bl.appendChild(bx);dc.appendChild(bl);
  });

  var fdg=div('fd-grid');
  var ff=div('fd-block forces');ff.innerHTML='<div class="fd-header fd-forces">✦ Forces du Duo</div><div class="fd-text">'+ld.forces+'</div>';
  var fd2=div('fd-block defis');fd2.innerHTML='<div class="fd-header fd-defis">⚡ Défis Énergétiques</div><div class="fd-text">'+ld.defis+'</div>';
  fdg.appendChild(ff);fdg.appendChild(fd2);dc.appendChild(fdg);

  var msg=div('');msg.style.cssText='background:linear-gradient(135deg,#f8f6f0,#fdfbf7);border:1px solid #e8d8b0;border-radius:10px;padding:18px;text-align:center;margin-top:18px';
  msg.innerHTML='<div style="font-size:14px;font-style:italic;color:#4a5568;line-height:1.7">"'+ld.message+'"</div>';
  dc.appendChild(msg);
  panel.appendChild(dc);

  // CTA
  var cta=div('cta-card fade-in-5');
  cta.innerHTML='<div class="cta-eyebrow">Aller plus loin</div>'
    +'<div class="cta-title">Approfondir votre pratique énergétique</div>'
    +'<div class="cta-text">Explorez nos formations en numérologie vibratoire, relations karmiques et soins énergétiques.</div>'
    +'<a href="https://www.unlieudelumiere.com/collections/all" class="cta-btn">Explorer les formations →</a>';
  panel.appendChild(cta);

  // Actions
  var ab=div('actions-bar fade-in-5');
  var bpdf=document.createElement('button');bpdf.className='btn-action btn-pdf';bpdf.innerHTML='📄 Télécharger le PDF';
  var bsh=document.createElement('button');bsh.className='btn-action btn-share';bsh.innerHTML='🔗 Copier le lien';
  var brs=document.createElement('button');brs.className='btn-action btn-reset';brs.innerHTML='↩ Nouvelle analyse';
  ab.appendChild(bpdf);ab.appendChild(bsh);ab.appendChild(brs);
  panel.appendChild(ab);

  var toast=div('share-toast');toast.id='shareToast';toast.textContent='✓ Lien copié !';
  panel.appendChild(toast);

  resPanel.appendChild(panel);
  resPanel.style.display='block';

  // Anime jauges
  requestAnimationFrame(function(){
    setTimeout(function(){
      root.getElementById('scoreFill').style.width=cd.score+'%';
      root.getElementById('gCv').style.width=cd.sCv+'%';
      root.getElementById('gAm').style.width=cd.sAm+'%';
      root.getElementById('gEx').style.width=cd.sEx+'%';
      root.getElementById('gPe').style.width=cd.sPe+'%';
    },200);
  });

  bpdf.addEventListener('click',function(){makePDF(cd,ai,si,duo);});
  bsh.addEventListener('click',function(){
    var url=window.location.href.split('?')[0]+'?compat='+btoa(unescape(encodeURIComponent(JSON.stringify({n1:cd.nom1,n2:cd.nom2,sc:cd.score,dn:cd.duoN}))));
    navigator.clipboard.writeText(url).then(function(){
      var t=root.getElementById('shareToast');t.style.display='block';setTimeout(function(){t.style.display='none';},3000);
    }).catch(function(){prompt('Copiez ce lien :',url);});
  });
  brs.addEventListener('click',function(){
    resPanel.style.display='none';resPanel.innerHTML='';
    root.getElementById('formPanel').style.display='block';scrollToMount();
  });
}

/* ── EVENTS ── */
function scrollToMount(){var r=mount.getBoundingClientRect();window.scrollTo({top:r.top+window.scrollY-80,behavior:'smooth'});}

['date1','date2'].forEach(function(id){
  root.getElementById(id).addEventListener('input',function(){
    formatDate(this);root.getElementById('errorMsg').style.display='none';
  });
});

root.getElementById('calcBtn').addEventListener('click',function(){
  var p1=root.getElementById('prenom1').value.trim();
  var n1=root.getElementById('nom1').value.trim();
  var d1=root.getElementById('date1').value;
  var p2=root.getElementById('prenom2').value.trim();
  var n2=root.getElementById('nom2').value.trim();
  var d2=root.getElementById('date2').value;
  var err=root.getElementById('errorMsg');

  if(!isValidDate(d1)||!isValidDate(d2)){
    err.textContent='Merci de saisir deux dates valides au format JJ/MM/AAAA.';
    err.style.display='block';return;
  }
  err.style.display='none';

  var cv1=cheminVie(d1),cv2=cheminVie(d2);
  var ex1=expression(p1,n1),ex2=expression(p2,n2);
  var am1=ame(p1,n1),am2=ame(p2,n2);
  var pe1=personnalite(p1,n1),pe2=personnalite(p2,n2);
  var sCv=compatScore(cv1,cv2),sEx=compatScore(ex1,ex2);
  var sAm=compatScore(am1,am2),sPe=compatScore(pe1,pe2);
  var score=Math.round(sCv*.35+sAm*.30+sEx*.20+sPe*.15);
  var dn=duoNum(cv1,cv2);
  var duo=getDuo(dn);

  var disp1=(p1||'Personne 1')+(n1?' '+n1.toUpperCase():'');
  var disp2=(p2||'Personne 2')+(n2?' '+n2.toUpperCase():'');

  var cd={prenom1:p1||'Personne 1',prenom2:p2||'Personne 2',nom1:disp1,nom2:disp2,
    cv1:cv1,cv2:cv2,am1:am1,am2:am2,ex1:ex1,ex2:ex2,pe1:pe1,pe2:pe2,
    sCv:sCv,sAm:sAm,sEx:sEx,sPe:sPe,score:score,duoN:dn,duoTitle:duo.t};

  root.getElementById('formPanel').style.display='none';
  root.getElementById('loadingPanel').style.display='block';
  scrollToMount();

  var steps=['Calcul des chemins de vie…',"Analyse des nombres d'âme…",'Lecture des expressions…','Génération de la lecture unique…'];
  var si2=0,stepEl=root.getElementById('loadingStep');
  var timer=setInterval(function(){si2=(si2+1)%steps.length;stepEl.textContent=steps[si2];},900);

  callClaude(cd).then(function(ai){
    clearInterval(timer);
    root.getElementById('loadingPanel').style.display='none';
    renderResults(cd,ai);
    scrollToMount();
  }).catch(function(e){
    console.error("Détail du plantage de l'analyse :", e);
    clearInterval(timer);
    root.getElementById('loadingPanel').style.display='none';
    root.getElementById('formPanel').style.display='block';
    err.textContent='Une erreur est survenue (' + e.message + '). Veuillez réessayer.';
    err.style.display='block';
  });
});
})();